import { ofetch } from "ofetch";
import useSWR from "swr";

import { GetReferenceTeaserSuccessResponse } from "@/api/paragraph/reference-teaser/[id]/route";
import { Loader } from "@/components/atoms/Loader";
import { Teaser } from "@/components/molecules/Teaser";
import { env } from "@/env";
import { ParagraphReferenceTeaser } from "@/graphql/sdk/__generated__";
import { cn } from "@/helpers/className";
import { useTranslation } from "@/i18n/client";
import { fallbackLng } from "@/i18n/settings";
import { AllowedLanguages } from "@/types/generic";

const fetcher = async (url: string) => {
  return await ofetch<GetReferenceTeaserSuccessResponse>(url, {
    next: {
      revalidate: 60,
    },
  });
};

interface ReferenceTeaserParagraphProps {
  className?: string;
  data: ParagraphReferenceTeaser;
}

export const ReferenceTeaserParagraph = ({
  data,
  className,
}: ReferenceTeaserParagraphProps) => {
  const {
    data: page,
    error,
    isLoading,
  } = useSWR<GetReferenceTeaserSuccessResponse, Error>(
    `${env.NEXT_PUBLIC_BASE_URL}/api/paragraph/reference-teaser/${data.contentRef.id}`,
    fetcher,
  );

  const { t } = useTranslation(
    (page?.langcode?.id as AllowedLanguages) ?? fallbackLng,
  );

  if (error || (!isLoading && !page)) return null;

  return (
    <div className={cn(className, "paragraph")}>
      {isLoading ? (
        <Loader size="small" />
      ) : (
        <Teaser
          title={page?.title ?? ""}
          media={page?.teaserMedia?.imageMediaImage ?? undefined}
          description={page?.intro?.processed ?? ""}
          link={{
            internal: true,
            title: t("components.reference_teaser_paragraph.read_more"),
            url: page?.path ?? "/",
          }}
        />
      )}
    </div>
  );
};
